import React from 'react';
import { Text, View } from 'react-native';
import { Add_type_str } from '../../utils/DictionaryManagementUtils';

const NewRow = ({ addNewRow }) => {
  const styles = {
    row: {
      flexDirection: 'row', height: 50,
    },
    squareIndex: {
      width: 30,
    },
    squareTypeID: {
      width: 100,
    },
    squareDescription: {
      width: 100,
    },
    squareServices: {
      flex: 1,
    },
    squareBorder: {
      padding: 5,
      border: 'solid 1px #cbd5e0',
    },

  };
  return (
    <View style={styles.row}>
      <View style={[styles.squareIndex, styles.squareBorder]} />
      <View style={[styles.squareTypeID, styles.squareBorder]}>
        <Text
          onPress={addNewRow}
          style={{
            fontSize: 14,
            marginVertical: 'auto',
            color: '#A0AEC0',
          }}
        >
          {Add_type_str}
        </Text>
      </View>
      <View style={[styles.squareDescription, styles.squareBorder]} />
      <View style={[styles.squareServices, styles.squareBorder]} />
    </View>
  );
};

export default NewRow;
